<template>
    <div class="account">
        <br>
        <el-form :inline="true" :model="formInline" :class="{elform:active}">
            <el-form-item label=" 出库日期:">
                <el-date-picker v-model="chartTimeValue"
                                :clearable="false"
                                type="daterange" align="center" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions2">
                </el-date-picker>
            </el-form-item>
            <el-form-item label='药品名:' class="distanceLeft">
                <el-input placeholder="请输入搜索内容" v-model="searchData"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" class="el-icon-search" @click="onSubmit"></el-button>
            </el-form-item>

            <el-form-item class="distanceLeft">
                <el-button type="primary" class="el-icon-download" @click.native="download()"></el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" stripe style="width: 98%;margin-left: 18px" row-key="rowkey" border
                  :header-cell-style="tableHeaderColor">
            <el-table-column type="index" label="序号" width="auto"></el-table-column>
            <el-table-column prop="medicineName" label="药品名称" width="auto"></el-table-column>

            <el-table-column prop="saleNunmber" label="数量">

            </el-table-column>
            <el-table-column prop="medicineUnit" label="单位" width="auto"></el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync=Current
                    :page-size="this.Size"
                    layout="total,prev, pager, next, jumper"
                    :total="this.total">
            </el-pagination>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .distanceLeft {
        margin-right: 10px;
    }
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .account {
        width: 99%;
        padding-bottom: 50px;
        background-color: white;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .el-table .warning-row {
        background: #ffaaa3;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    el-input {
        width: 100px;
    }

    .stylecolor {
        color: red;
    }

    .elform {
        float: right;
        margin-right: 10px;
        padding-left: 20px;
    }

</style>

<script>
import {formatDate} from "../../common/date";

export default {
  username: 'account',
  data() {
    return {
        downloadList:[], //下载清单列表
      Current: 1,
      Size: 10,
      searchData: '',          //  搜索数据
      data: {},
      currentPage: 1,
      total: 0,
      tableData: [],
      currentPage1: 3,
      inputvalue: '',
      chartTimeValue: [Date.now(), Date.now()],
      leftNum: 900,
      active: true,
      formInline: {
        user: '',
        region: '',
        account: '',
      },
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

    }
  },

  //实例化就获取数据
  mounted: function () {
    this.data = {
      startDate: formatDate(this.chartTimeValue[0], 'yyyy-MM-dd'),
      endDate: formatDate(this.chartTimeValue[1], 'yyyy-MM-dd'),
    }
    this.getinfo();
  },

  methods: {
      // 下载excel
      download(){
          this.$axios({
              url: '/api/medicine/sale/summary/pageNumber/'+this.Current+'/size/'+ 10000,
              method: 'POST',
              data: this.data
          }).then(res => {
              this.downloadList = res.data.data.content;
//                  this.total = res.data.data.totalElements;
              require.ensure([], () => {
                  const { export_json_to_excel } = require('../../vendor/Export2Excel.js');　　//引入文件　　　　　　
                  const tHeader = ['药品名称', '数量', '单位']; //将对应的属性名转换成中文
                  // const tHeader = [];

                  const filterVal = ['medicineName', 'saleNunmber', 'medicineUnit'];//table表格中对应的属性名　　　　　 　　　
                  const list = this.downloadList;
                  const data = this.formatJson(filterVal, list);

                  var filename = '出库列表' + new Date().toLocaleDateString()
                  export_json_to_excel(tHeader, data, filename);
              })

          }).catch(err => {
              console.log(err.data);
          })


      },

      formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => v[j]))
      },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";
      }
    },
    getinfo: function () {
      this.$axios({
        url: '/api/medicine/sale/summary/pageNumber/'+this.Current+'/size/'+ this.Size,
        method: 'POST',
        data: this.data
      }).then(res => {
        this.tableData=res.data.data.content;
        this.total = res.data.data.totalElements;
      }).catch(err => {
        console.log(err.data);
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.Size = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.Current = val;
      this.getinfo();
    },
    onSubmit: function () {
      this.Current=1;
      this.data.startDate = formatDate(this.chartTimeValue[0], 'yyyy-MM-dd');
      this.data.endDate = formatDate(this.chartTimeValue[1], 'yyyy-MM-dd');
      this.data.medicineName = this.searchData;
      this.getinfo();
    }
  },
}

</script>




// WEBPACK FOOTER //
// outSummary.vue?be51e8f0